import {event, timePickerOptionsEnd, timePickerOptionsStart} from './state';
import moment from 'moment';

export function setUsers(state, leadership) {

    leadership.leadership_users.map(l => {
        l.id = l.user_id;
        l.name = l.user.name + (!!l.user.surname ? ' ' + l.user.surname : '');
        l.contact_id = l.user.contact_id;
        l.role = '';

        if (!!l.user.get_roles && l.user.get_roles[0]) {
            l.role = l.user.get_roles[0].role;
        }
    });

    let ls = state.leaderships.find(l => l.user_id === state.user.id);

    if (!!ls) {
        let user = state.user;
        user.name = user.name + (!!user.surname ? ' ' + user.surname : '');

        leadership.leadership_users.unshift(user);
    }

    state.users = leadership.leadership_users;
}

export function setTotalUsers(state, users) {

    users.map(u => {
        u.name = u.name + (!!u.surname ? ' ' + u.surname : '');

        u.role = '';

        if (!!u.get_roles && u.get_roles[0]) {
            u.role = u.get_roles[0].role;
        }
    });

    state.users = users;
}

export function setLeaderships(state, leaderships) {
    state.leaderships = leaderships;
}

export function setContacts(state, contacts) {
    contacts.map(c => {
        let type = [];

        if (c.is_customer){
            type.push('CLIENTE')
        }

        if (c.is_provider){
            type.push('PROVEEDOR')
        }

        if (c.is_employee){
            type.push('EMPLEADO')
        }

        c.type = type.join(' | ')


        c.name = c.name + (!!c.surname ? ' ' + c.surname : '');
    })

    state.contacts = contacts;
}

export function setContactsWarehouses(state, contacts_warehouses) {
    const pattern = new RegExp('^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}');

    if (state.coordinates.value) {
        let coordinates = state.coordinates.value.split(',');

        if (!!coordinates[0] && !!coordinates[1] && pattern.test(coordinates[0]) && pattern.test(coordinates[1])) {

            let lat1 = coordinates[0];
            let lng1 = coordinates[1];

            contacts_warehouses.map(cw => {

                cw.distance = 'N/R';
                cw.distance_number = 100000;

                let lat2 = cw.latitude;
                let lng2 = cw.length;

                if (pattern.test(lat2) && pattern.test(lng2)) {
                    const R = 6378137;
                    const dLat = (lat2 - lat1) * Math.PI / 180;
                    const dLong = (lng2 - lng1) * Math.PI / 180;
                    const dLat1 = (lat1) * Math.PI / 180;

                    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(dLat1) * Math.cos(dLat1) * Math.sin(dLong / 2) * Math.sin(dLong / 2);

                    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

                    let distance = (Math.round(R * c * 0.001 * 10) / 10);

                    cw.distance = distance + ' Kms';
                    cw.distance_number = distance;
                }
            });
        }
    }

    state.contacts_warehouses = contacts_warehouses.sort((a, b) => {
        return a.distance_number - b.distance_number;
    });
}

export function updateDistance(state, event) {
    const pattern = new RegExp('^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}');

    let lat1;
    let lng1;

    if (event && event.contact_warehouse) {
        const contact_warehouse = event.contact_warehouse;

        state.title_distance = 'Dist ' + contact_warehouse.description.substring(0, 6) + '...';

        lat1 = contact_warehouse.latitude;
        lng1 = contact_warehouse.length;
    } else {
        state.title_distance = 'Dist';

        navigator.geolocation.getCurrentPosition(
            position => {
                lat1 = position.coords.latitude;
                lng1 = position.coords.longitude;
            },
            error => {
                console.log(error.message);
            },
        );
    }

    if (!!lat1 && !!lng1 && pattern.test(lat1) && pattern.test(lng1)) {
        state.contacts_warehouses.map(cw => {

            cw.distance = 'N/R';
            cw.distance_number = 100000;

            let lat2 = cw.latitude;
            let lng2 = cw.length;

            if (pattern.test(lat2) && pattern.test(lng2)) {
                const R = 6378137;
                const dLat = (lat2 - lat1) * Math.PI / 180;
                const dLong = (lng2 - lng1) * Math.PI / 180;
                const dLat1 = (lat1) * Math.PI / 180;

                const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(dLat1) * Math.cos(dLat1) * Math.sin(dLong / 2) * Math.sin(dLong / 2);

                const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

                let distance = (Math.round(R * c * 0.001 * 10) / 10);

                cw.distance = distance + ' Kms';
                cw.distance_number = distance;
            }
        });
    }

    state.contacts_warehouses = state.contacts_warehouses.sort((a, b) => {
        return a.distance_number - b.distance_number;
    });
}

export function setModalShow(state, show) {
    state.modal.show = show;
}

export function setModalAdvancedShow(state, show) {
    state.modal_advanced.show = show;
}

export function setTimePickerOptions(state) {
    state.time_picker_options_start = timePickerOptionsStart();
    state.time_picker_options_end = timePickerOptionsEnd();

    if (state.action !== 'Ver') {
        const current_date = moment().format('YYYY-MM-DD');

        if ((state.action === 'Crear' || state.action === 'Editar') && state.event.start_date === current_date) {
            const current_hour = moment().format('HH');
            const current_minute = moment().format('mm');

            let minute = '00';
            let hour = current_hour;

            if (+current_minute < 30) {
                minute = '30';
            } else {
                if (+current_hour < 9) {
                    hour = '0' + (+current_hour + 1);
                } else {
                    hour = +current_hour + 1;
                }
            }

            let start_time = hour + ':' + minute;

            state.time_picker_options_start.start = start_time;
            state.time_picker_options_end.start = start_time;
        }
    }
}

export function setTimePickerOptionsEnd(state, time_picker_options_end) {
    state.time_picker_options_end = time_picker_options_end;
}

export function resetEvent(state, event_data) {
    state.event = event();

    state.event.start_date = moment(event_data.startTime).format('YYYY-MM-DD');
    state.event.end_date = moment(event_data.endTime).format('YYYY-MM-DD');

    state.event.start_time = moment(event_data.startTime).format('HH:mm');
    state.event.end_time = moment(event_data.endTime).format('HH:mm');
}

export function setEvent(state, event) {
    state.event = event;

    if (!!event.startTime && !!event.endTime) {
        state.event.start_date = moment(event.startTime).format('YYYY-MM-DD');
        state.event.end_date = moment(event.endTime).format('YYYY-MM-DD');

        state.event.start_time = moment(event.startTime).format('HH:mm');
        state.event.end_time = moment(event.endTime).format('HH:mm');
    } else {
        state.event.startTime = moment(event.start_date + ' ' + event.start_time).toDate();
        state.event.endTime = moment(event.end_date + ' ' + event.end_time).toDate();
    }

    state.event.attachments_loaded = [];
    state.event.attachments_deleted = [];
}

export function setEventDescription(state, description) {
    state.event.description = description;
}

export function setEventAddress(state, address) {
    state.event.address = address;
}

export function setEventTelephone(state, telephone) {
    state.event.telephone = telephone;
}

export function setEventEndTime(state, end_time) {
    state.event.end_time = end_time;
}


export function setEventEndDate(state, end_date) {
    state.event.end_date = end_date;
}

export function setEventLeaderShipId(state, leadership_id) {
    state.event.leadership_id = leadership_id;
}

export function setEventUserId(state, user_id) {
    state.event.user_id = user_id;
}

export function setEventContactWarehouseId(state, contact_warehouse_id) {
    state.event.contact_warehouse_id = contact_warehouse_id;
}

export function setEventEditMode(state, edit_mode) {
    state.event.edit_mode = edit_mode;
}

export function setAction(state, action) {
    state.action = action;
}

export function setDisabledObservation(state, disabled_observation) {
    state.disabled_observation = disabled_observation;
}

export function setEvents(state, events) {
    events.map(e => {
        e.attachments_loaded = e.attachments;

        if (!!e.visit_customer) {
            let checkin_date = moment(e.visit_customer.checkin_date);
            let checkout_date = moment(e.visit_customer.checkout_date);

            e.visit_customer.checkin_date = checkin_date.format('YYYY-MM-DD');
            e.visit_customer.checkout_date = checkout_date.format('YYYY-MM-DD');

            e.visit_customer.checkin_time = checkin_date.format('HH:mm');
            e.visit_customer.checkout_time = checkout_date.format('HH:mm');
        }

    });

    state.events = events;
}

export function setEventsDay(state, events_day) {
    state.events_day = events_day;
}

export function setLoadingEditor(state, loading_editor) {
    state.loading_editor = loading_editor;
}

export function setParametersStartDate(state, start_date) {
    state.parameters.start_date = start_date;
}

export function setParametersEndDate(state, end_date) {
    state.parameters.end_date = end_date;
}

export function setParametersUserId(state, user_id) {
    state.parameters.user_id = user_id;
}

export function setLeadershipId(state, leadership_id) {
    state.parameters.leadership_id = leadership_id;
}

export function setEditMode(state, edit_mode) {
    state.edit_mode = edit_mode;
}

export function addAttachmentDeleteEvent(state, attachment) {
    state.event.attachments_deleted.push(attachment);
}

export function setAttendedEvent(state, attended) {
    state.event.attended = attended;
}

export function deleteAttachmentEvent(state, attachment) {
    let attachments = JSON.parse(JSON.stringify(state.event.attachments));

    let index_attachment = attachments.findIndex(a => a.id === attachment.id);

    if (index_attachment >= 0) {
        attachments.splice(index_attachment, 1);
    }

    state.event.attachments = attachments;
}

export function setAllowClose(state, allow_close) {
    state.allow_close = allow_close;
}

export function setCoordinates(state, coordinates) {
    state.coordinates.value = coordinates;
}

export function setCoordinatesUser(state, coordinates) {
    state.coordinates.user = coordinates;
}

export function setHolidays(state, holidays) {
    state.holidays = holidays;
}

export function setUser(state) {
    state.user = JSON.parse(localStorage.user);
}










// WEBPACK FOOTER //
// ./src/modules/schedule/mutations.js